import { get_api_path } from "services/api";
import { store } from "../store";
import { sessioned_client } from "./auth";

export async function list({ query }) {
  const url = get_api_path("lesson/list", query);
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).get(url);
  const { models, meta } = response.data.result;
  return { models, meta };
};

export async function detail(lesson_id) {
  const url = get_api_path("lesson/detail", {}, { lesson_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).get(url);
  const { model } = response.data.result;
  return { model };
};

export async function del(lesson_id) {
  const url = get_api_path("lesson/delete", {}, { lesson_id });
  const { token } = store.getState().profile;
  await sessioned_client(token).delete(url);
};

export async function update(lesson_id, data) {
  const url = get_api_path("lesson/update", {}, { lesson_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).post(url, data);
  const { model } = response.data.result;
  return { model };
};

export async function create(data) {
  const url = get_api_path("lesson/create");
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).post(url, data);
  const { model } = response.data.result;
  return { model };
};

export async function set_teachers(lesson_id, data) {
  const url = get_api_path("lesson/teacher", {}, { lesson_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).post(url, data);
  const { model } = response.data.result;
  return { model };
};

export async function set_modules(lesson_id, data) {
  const url = get_api_path("lesson/module", {}, { lesson_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).post(url, data);
  const { model } = response.data.result;
  return { model };
};

export async function set_masteries(lesson_id, data) {
  const url = get_api_path("lesson/mastery", {}, { lesson_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).post(url, data);
  const { model } = response.data.result;
  return { model };
};

export async function add_slots(lesson_id, data) {
  const url = get_api_path("lesson/slot/create", {}, { lesson_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).post(url, data);
  return response;
};

export async function schedule(lesson_id, { query }) {
  const url = get_api_path("lesson/schedule", query, { lesson_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).get(url);
  const { models, meta } = response.data.result;
  return { models, meta };
};